// import { TextFieldEntry, isTextFieldEntryEdited } from '@bpmn-io/properties-panel';
import { useService } from "bpmn-js-properties-panel";
import { html } from "htm/preact";

export default function (element) {
  return {
      id: "name",
      element,
      component: collaborationNameProps,
      isEdited: true,
    };
}

function collaborationNameProps(props) {
  const { element, id } = props;

  const modeling = useService("modeling");
  const translate = useService("translate");
  const debounce = useService("debounceInput");

  const getValue = () => {
    return element.businessObject.name || "";
  };

  const setValue = (value) => {
    console.log(value);
    return modeling.updateProperties(element, {
      name: value.target.value,
    });
  };

   // var asdf = html`<input type='text' value='asdf'/>aaaaaa`
  // return htmlpreact`${asdf}`;
  //return html`<input type='text' id=${ id } class='bio-properties-panel-input' value=${getValue()} setValue=${setValue}/>`
  return html`<div class="bio-properties-panel-entry" data-entry-id="name"><div class="bio-properties-panel-textfield">
  <label for="bio-properties-panel-name" class="bio-properties-panel-label">Name</label>
  <input id="bio-properties-panel-name" type="text" name="id" spellcheck="false" autocomplete="off" class="bio-properties-panel-input"
  value=${getValue()}
  oninput=${setValue}
  /></div></div>`
  ;
}
//     return html`<TextFieldEntry
//       id={ id }
//       element={ element }
//       description={ translate('Link to the subprocess') }
//       label={ translate('callActivity URL') }
//       getValue={ getValue }
//       setValue={ setValue }
//       debounce={ debounce }
//     />`
// }
